<template>
  <div class="animated fadeIn">
    <table v-if="items" class="table table-hover table-striped table-bodered">
      <thead>
        <tr>
          <th class="text-center">#</th>
          <th class="text-center">Code</th>
          <th class="text-center">Name</th>
          <th class="text-right">Price</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <td>{{item}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  name: "Payments",
  data() {
    return {
      items: null,
      item: null
    };
  },
  mounted() {
    this.gets();
  },
  methods: {
    gets() {
      firebase
        .firestore()
        .collection("payments")
        .onSnapshot(snapshot => {
          let items = [];
          snapshot.forEach(doc => {
            let item = doc.data();
            item.id = doc.id;
            items.push(item);
          });
          this.items = items;
        });
    },
    add() {
      this.item = {};
    },
    edit(item) {
      this.item = item;
    },
    remove(item) {
      Swal.fire({
        title: "Are you sure?",
        type: "question",
        confirmButtonText: "Yes",
        confirmButtonColor: "#22dd33",
        showCancelButton: true,
        cancelButtonText: "No",
        cancelButtonColor: "#dd2233"
      }).then(res => {
        if (res.value) {
          firebase
            .firestore()
            .collection("payments")
            .doc(item.id)
            .delete()
            .then(() => {
              Swal.fire("Success", "", "success");
            })
            .catch(e => {
              Swal.fire("Error", JSON.stringify(e), "success");
            });
        }
      });
    }
  }
};
</script>

<style>
</style>
